import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CategoryList.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function CategoryList({ categories }) {

  function Category({ category }) {
    const [expanded, setExpanded] = useState(false);
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const toggleCategory = () => {
      setExpanded(!expanded);
    };

    useEffect(() => {
      const hasSubcategories = (cat) => {
        return cat.subCategories?.length > 0;
      };

      if (expanded && !hasSubcategories(category)) {
        setIsLoading(true);
        fetch(`${API_BASE_URL}/products?categoryId=${category.categoryID}&productType=selling`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Failed to fetch products: ${response.statusText}`);
            }
            return response.json();
          })
          .then(data => {
            setProducts(data.products || []);
          })
          .catch(error => {
            setProducts([]);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }, [expanded, category]);

    return (
      <li key={category.categoryID} className="category-list-item">
        <div className="category-list-header" onClick={toggleCategory}>
          <span className="category-list-name">{category.name}</span>
          <span className="category-list-toggle">
            {expanded ? '▼' : '▶'}
          </span>
        </div>
        {expanded && (
          <>
            {category.subCategories?.length > 0 ? (
              <ul className="category-list">
                {category.subCategories.map(subCategory => (
                  <Category key={subCategory.categoryID} category={subCategory} />
                ))}
              </ul>
            ) : isLoading ? (
              <div className="category-list-loading">Loading products...</div>
            ) : (
              <ul className="category-list-product-list">
                {products.length > 0 ? (
                  products.map(product => (
                    <li key={product.productID} className="category-list-product-item">
                      <Link to={`/product/${product.productCode}`} className="category-list-product-link">
                        {product.name}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li className="category-list-product-item">No products found</li>
                )}
              </ul>
            )}
          </>
        )}
      </li>
    );
  }

  return (
    <ul className="category-list">
      {categories.map(category => (
        <Category key={category.categoryID} category={category} />
      ))}
    </ul>
  );
}

export default CategoryList;